function nowValue(now) {
    return now ? now() : Date.now();
}
export function saveOtpState(deps, args) {
    try {
        const expiresAt = nowValue(deps.now) + args.ttlSeconds * 1000;
        const payload = {
            phone: args.phone,
            channel: args.channel,
            expiresAt,
            personalDataConsentAccepted: args.personalDataConsentAccepted,
            codeLength: args.codeLength,
            ...(args.extras || {}),
        };
        const serialized = JSON.stringify(payload);
        deps.storage.setItem(deps.otpStateKey, serialized);
        deps.writeCookie(deps.otpStateCookieKey, serialized, args.ttlSeconds);
        if (args.channel === "call_me" &&
            typeof payload.attemptId === "string" &&
            payload.attemptId.trim() !== "") {
            deps.writeCallMeStateToUrl({
                phone: args.phone,
                attemptId: payload.attemptId.trim(),
                routingKey: typeof payload.routingKey === "string"
                    ? payload.routingKey.trim()
                    : "",
                expiresAt,
                personalDataConsentAccepted: args.personalDataConsentAccepted,
            });
        }
        else {
            deps.clearCallMeStateFromUrl();
        }
    }
    catch {
        // ignore
    }
}
export function loadOtpState(deps) {
    try {
        const raw = deps.storage.getItem(deps.otpStateKey) ||
            deps.readCookie(deps.otpStateCookieKey);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.expiresAt !== "number")
            return null;
        if (parsed.expiresAt <= nowValue(deps.now)) {
            deps.storage.removeItem(deps.otpStateKey);
            deps.clearCookie(deps.otpStateCookieKey);
            return null;
        }
        deps.storage.setItem(deps.otpStateKey, raw);
        deps.writeCookie(deps.otpStateCookieKey, raw, Math.ceil((parsed.expiresAt - nowValue(deps.now)) / 1000));
        return parsed;
    }
    catch {
        return null;
    }
}
export function clearOtpState(deps) {
    try {
        deps.storage.removeItem(deps.otpStateKey);
    }
    catch {
        // ignore
    }
    deps.clearCookie(deps.otpStateCookieKey);
    deps.clearCallMeStateFromUrl();
}
export function readStoredCallMeState(deps, normalizePhoneForApi, expectedPhone) {
    const stored = loadOtpState(deps) ??
        (() => {
            const urlState = deps.readCallMeStateFromUrl();
            if (!urlState) {
                return null;
            }
            return {
                phone: urlState.phone,
                channel: "call_me",
                expiresAt: urlState.expiresAt,
                personalDataConsentAccepted: urlState.personalDataConsentAccepted,
                codeLength: 0,
                attemptId: urlState.attemptId,
                routingKey: urlState.routingKey,
            };
        })();
    if (!stored || stored.channel !== "call_me") {
        return null;
    }
    if (expectedPhone) {
        const normalizedExpectedPhone = normalizePhoneForApi(expectedPhone);
        const normalizedStoredPhone = normalizePhoneForApi(stored.phone);
        if (normalizedExpectedPhone &&
            normalizedStoredPhone &&
            normalizedExpectedPhone !== normalizedStoredPhone) {
            return null;
        }
    }
    const attemptId = typeof stored.attemptId === "string" ? stored.attemptId.trim() : "";
    const routingKey = typeof stored.routingKey === "string" ? stored.routingKey.trim() : "";
    if (!attemptId) {
        return null;
    }
    return { attemptId, routingKey };
}
export function readStoredOtpStateForRestore(deps) {
    const stored = loadOtpState(deps);
    if (stored) {
        return stored;
    }
    const urlState = deps.readCallMeStateFromUrl();
    if (!urlState) {
        return null;
    }
    return {
        phone: urlState.phone,
        channel: "call_me",
        expiresAt: urlState.expiresAt,
        personalDataConsentAccepted: urlState.personalDataConsentAccepted,
        codeLength: 0,
        attemptId: urlState.attemptId,
        routingKey: urlState.routingKey,
    };
}
